import { render, staticRenderFns } from "./HistoryButton.vue?vue&type=template&id=00d7d250"
import script from "./HistoryButton.vue?vue&type=script&lang=ts"
export * from "./HistoryButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d7d250')) {
      api.createRecord('00d7d250', component.options)
    } else {
      api.reload('00d7d250', component.options)
    }
    module.hot.accept("./HistoryButton.vue?vue&type=template&id=00d7d250", function () {
      api.rerender('00d7d250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/HistoryButton.vue"
export default component.exports